export const BH_CASA_REPOUSO_DOMICILIO_ID = 8;
export const SP_CASA_REPOUSO_DOMICILIO_ID = 39;
